transformations = {
    "meta.pubtype": {
        "UM": "User\u2019s manual",
        "GSG": "Getting Started",
        "technote": "Notice to customer"
    }
};

//# sourceMappingURL=se.simonsoft.dita.flir.public.8b278812.js.map
